<template>
  <v-dialog v-model="confirmDialog.dialog" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ confirmDialog.title }}</v-card-title>

      <v-card-text>
        {{ confirmDialog.message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text="text" @click="disagree">
          {{ confirmDialog.cancelTitle }}
        </v-btn>

        <v-btn color="red darken-1" text="text" @click="agree">
          {{ confirmDialog.okTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    confirmDialog: Object
  },
  methods: {
    disagree() {
      this.confirmDialog.dialog = false;
    },

    agree() {
      this.confirmDialog.dialog = false;
      if (typeof this.confirmDialog.success === "function") {
        this.confirmDialog.success();
      }
    }
  }
};
</script>

<style scoped></style>
